(ns client-portal.client.locations.views
  (:require [client-portal.client.locations.data]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(defn locations-dropdown [_]
  (let [locations- (re/subscribe [:locations/by-current-concept-id-])
        selected-id- (re/subscribe [:locations/current-selected-location-id-])]
    (fn [{:keys [on-change] :as args}]
      [alc/up-popover-button-dropdown (merge args
                                             {:placeholder "All Locations"
                                              :search? true
                                              :no-results-message "No locations found."
                                              :loading (util/loading? @locations-)
                                              :on-change (or on-change #(re/dispatch [:concepts/select %]))
                                              :options (some->> (util/when-not-loading @locations-)
                                                                (mapv (fn [{:keys [id label]}]
                                                                        {:text label
                                                                         :value id
                                                                         :icon-type :LocationIcon
                                                                         :selected? (= @selected-id- id)})))})])))
